import styled from "styled-components";

export const MainContainer = styled.div`
padding: 10px 0;
    li {
        color: var(--error-color);
        font-size: 12px;
        font-weight: bold;
    }
`;